import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ImportJurisdictionBoundariesMutationVariables = Types.Exact<{
  input: Types.ImportJurisdictionBoundariesInput;
}>;


export type ImportJurisdictionBoundariesMutation = { __typename?: 'mutation_root', import_jurisdiction_boundaries?: { __typename?: 'ImportJurisdictionBoundariesOutput', success: boolean, import_id?: any | null, error?: string | null } | null };


export const ImportJurisdictionBoundariesDocument = gql`
    mutation importJurisdictionBoundaries($input: ImportJurisdictionBoundariesInput!) {
  import_jurisdiction_boundaries(input: $input) {
    success
    import_id
    error
  }
}
    `;
export type ImportJurisdictionBoundariesMutationFn = Apollo.MutationFunction<ImportJurisdictionBoundariesMutation, ImportJurisdictionBoundariesMutationVariables>;

/**
 * __useImportJurisdictionBoundariesMutation__
 *
 * To run a mutation, you first call `useImportJurisdictionBoundariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportJurisdictionBoundariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importJurisdictionBoundariesMutation, { data, loading, error }] = useImportJurisdictionBoundariesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportJurisdictionBoundariesMutation(baseOptions?: Apollo.MutationHookOptions<ImportJurisdictionBoundariesMutation, ImportJurisdictionBoundariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportJurisdictionBoundariesMutation, ImportJurisdictionBoundariesMutationVariables>(ImportJurisdictionBoundariesDocument, options);
      }
export type ImportJurisdictionBoundariesMutationHookResult = ReturnType<typeof useImportJurisdictionBoundariesMutation>;
export type ImportJurisdictionBoundariesMutationResult = Apollo.MutationResult<ImportJurisdictionBoundariesMutation>;
export type ImportJurisdictionBoundariesMutationOptions = Apollo.BaseMutationOptions<ImportJurisdictionBoundariesMutation, ImportJurisdictionBoundariesMutationVariables>;